/* tslint:disable */
/* eslint-disable */
export enum CustomerTypeEnum {
  NotSet = 0,
  AnnonsKund = 1,
  SkyltKund = 2
}
